import React from 'react';
import { useGoBack } from '../../../../../utils/appNavigationNames';
import { AnimateLoadedContent } from '../../../../v2BaseComponents/Loader';
import { useIsDisabledByParent } from '../../../../v2BaseComponents/IsDisabledProvider';
import { Form } from '../../../../v2BaseComponents/Form';
import useOrganizationInvitationDefinitions from '../../../../../hooks/api/useOrganizationInvitationDefinitions';
import FormFields, {
    mapFormValuesToRequest,
    defaultFormValues,
} from '../../../../shared/InvitationDefinitions/FormFields';

export type AddInvitationDefinitionScreenOwnProps = {};

export type AddInvitationDefinitionScreenProps = AddInvitationDefinitionScreenOwnProps;

const AddInvitationDefinitionScreen: React.FC<AddInvitationDefinitionScreenProps> = (_props) => {
    const goBack = useGoBack();
    const { isCreatingInvitationDefinition, createInvitationDefinition } = useOrganizationInvitationDefinitions({
        onCreateInvitationDefinition: goBack,
    });
    const isDisabledByParent = useIsDisabledByParent(isCreatingInvitationDefinition);
    return (
        <AnimateLoadedContent isLoading={isCreatingInvitationDefinition}>
            {() => (
                <Form
                    fillContainer
                    actionContainerSubmit
                    initialValues={defaultFormValues}
                    onSubmit={(values) => createInvitationDefinition(mapFormValuesToRequest(values))}
                    isDisabled={isDisabledByParent}
                    onCancel={goBack}
                >
                    {({ isSubmitting, values }) => (
                        <FormFields
                            isDisabled={isDisabledByParent || isSubmitting}
                            value={values}
                            initialValues={defaultFormValues}
                        />
                    )}
                </Form>
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(AddInvitationDefinitionScreen);
